import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "layout-landing__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_header = _resolveComponent("app-header")!
  const _component_landing_slider = _resolveComponent("landing-slider")!

  return (_openBlock(), _createElementBlock("div", {
    class: "layout-landing",
    style: _normalizeStyle({ backgroundColor: _ctx.bgColor })
  }, [
    _createVNode(_component_app_header, {
      class: "layout-landing__header",
      simplified: ""
    }),
    _createElementVNode("main", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _createVNode(_component_landing_slider, {
      class: "layout-landing__slider",
      onChangeBg: _ctx.changeBg
    }, null, 8, ["onChangeBg"])
  ], 4))
}